//* GETTER CONSTANT
export const getters = {
  // TODO: GET CONSTANT DECLARATION
  GET_STRATEGY_ESTABILSHMENT_LIST: 'GET_STRATEGY_ESTABILSHMENT_LIST', //* 전략 과제 리스트 가져오기
  GET_STRATEGY_ESTABILSHMENT_ITEM: 'GET_STRATEGY_ESTABILSHMENT_ITEM', //* 전략 과제 아이템 가져오기
  GET_STRATEGY_ESTABILSHMENT_CONNECT_LIST:
    'GET_STRATEGY_ESTABILSHMENT_CONNECT_LIST', //* 전략과제 연결 정보(과제,KPI) 가져오기
  GET_STRATEGY_EXCEL_DATA: 'GET_STRATEGY_EXCEL_DATA', //* 전략과제 EXCEL 데이터 가져오기
  GET_UPLOAD_EXCEL_FORM: 'GET_UPLOAD_EXCEL_FORM', //* 전략과제 EXCEL 업로드 양식 가져오기

  GET_KPI_INFO: 'GET_KPI_INFO', //* KPI명 가져오기
  GET_KPI_SEARCH_LIST: 'GET_KPI_SEARCH_LIST', //* 검색한 KPI 목록 가져오기
  GET_FILE_LIST: 'GET_FILE_LIST', //* 파일 정보 가져오기
  GET_STG_SEARCH_INFO: 'GET_STG_SEARCH_INFO', //* 전략과제 조회시 검색 정보
  GET_UPPER_DEPT: 'GET_UPPER_DEPT', //* 상위 부서 검색
  GET_VIEWS_KPI_SEARCH_POPUP: 'GET_VIEWS_KPI_SEARCH_POPUP', //* KPI 검색 팝업 ON/OFF 가져오기
  GET_VIEWS_DEPARTMENT_SEARCH_POPUP: 'GET_VIEWS_DEPARTMENT_SEARCH_POPUP', //* 부서 검색 팝업 ON/OFF 가져오기
  GET_VIEWS_MANAGER_SEARCH_POPUP: 'GET_VIEWS_MANAGER_SEARCH_POPUP', //* 담당자 검색 팝업 ON/OFF 가져오기
  GET_VIEWS_EXCEL_UPLOAD_POPUP: 'GET_VIEWS_EXCEL_UPLOAD_POPUP', //* 파일 업로드 팝업 ON/OFF 가져오기
  GET_INPUT_STRATEGY_INVALID: 'GET_INPUT_STRATEGY_INVALID', //* 전략과제 신규 및 수정 FORM 유효성 결과 가져오기
  GET_VIEWS_FILES_UPLOAD_POPUP: 'GET_VIEWS_FILES_UPLOAD_POPUP', //* EXCEL 업로드 팝업 ON/OFF
  GET_IS_GRID_DRAG: 'GET_IS_GRID_DRAG', //* 그리드 드래그온 드롭 ON/OFF
};

//* ACTION CONSTANT
/*
! FETCH, INSERT, UPDATE, DELETE: 비동기으로 인한 데이터 서버 전송 및 내부 STATE 변경 시
! INIT: 컴포넌트 내부에서 STATE 변경 시
*/
export const actions = {
  // TODO: FETCH CONSTANT DECLARATION
  FETCH_STRATEGY_ESTABILSHMENT_LIST: 'FETCH_STRATEGY_ESTABILSHMENT_LIST', //* 전략과제 리스트 가져오기
  FETCH_STRATEGY_ESTABILSHMENT_ITEM: 'FETCH_STRATEGY_ESTABILSHMENT_ITEM', //* 단일 전략과제 가져오기

  FETCH_STRATEGY_ESTABILSHMENT_CONNECT_LIST:
    'FETCH_STRATEGY_ESTABILSHMENT_CONNECT_LIST', //* 전략과제 연결 정보(과제,KPI) 가져오기
  FETCH_UPLOAD_EXCEL_FORM: 'FETCH_UPLOAD_EXCEL_FORM', //* 전략과제 EXCEL 업로드 양식 가져오기
  FETCH_KPI_LSIT: 'FETCH_KPI_LSIT', //* KPI 리스트 가져오기
  FETCH_KPI_SEARCH_LIST: 'FETCH_KPI_SEARCH_LIST', //* KPI 검색 리스트 가져오기
  FETCH_UPPER_DEPT: 'FETCH_UPPER_DEPT', //* 상위 부서 검색

  // FETCH_FILE_LIST: 'FETCH_FILE_LIST', //* 파일 정보 가져오기

  // TODO: INSERT CONSTANT DECLARATION
  INSERT_STRATEGY_ESTABILSHMENT_ITEM: 'INSERT_STRATEGY_ESTABILSHMENT_ITEM', //* 전략과제 아이템 등록

  // TODO: UPDATE CONSTANT DECLARATION
  UPDATE_STRATEGY_ESTABILSHMENT_LIST: 'UPDATE_STRATEGY_ESTABILSHMENT_LIST', //* 전략과제 리스트 업데이트
  UPDATE_STRATEGY_ESTABILSHMENT_ITEM: 'UPDATE_STRATEGY_ESTABILSHMENT_ITEM', //* 전략과제 아이템 업데이트
  UPDATE_LAST_STG: 'UPDATE_LAST_STG', //* 전년도 전략체계도 복사

  // TODO: DELETE CONSTANT DECLARATION
  DELETE_STRATEGY_ESTABILSHMENT_ITEM: 'DELETE_STRATEGY_ESTABILSHMENT_ITEM', //* 전략과제 아이템 삭제

  // TODO: INIT CONSTANT DECLARATION

  INIT_STRATEGY_ESTABILSHMENT_LIST: 'INIT_STRATEGY_ESTABILSHMENT_LIST', //* 전략과제 리스트 초기화
  INIT_STRATEGY_ESTABILSHMENT_ITEM: 'INIT_STRATEGY_ESTABILSHMENT_ITEM', //* 전략과제 아이템 초기화

  INIT_STRATEGY_ESTABILSHMENT_CONNECT_LIST:
    'INIT_STRATEGY_ESTABILSHMENT_CONNECT_LIST', //* 전략과제 연결 정보(과제,KPI) 초기화
  INIT_STRATEGY_EXCEL_DATA: 'INIT_STRATEGY_EXCEL_DATA', //* 전략과제 EXCEL 데이터 초기화
  INIT_UPLOAD_EXCEL_FORM: 'INIT_UPLOAD_EXCEL_FORM', //* 전략과제 EXCEL 업로드 양식 초기화

  INIT_KPI_INFO: 'INIT_KPI_INFO', //* KPI명 초기화
  INIT_KPI_SEARCH_LIST: 'INIT_KPI_SEARCH_LIST', //* KPI 검색 리스트 초기화
  INIT_FILE_LIST: 'INIT_FILE_LIST', //* 파일 정보 초기화
  INIT_STG_SEARCH_INFO: 'INIT_STG_SEARCH_INFO', //* 전략과제 조회시 검색 정보 초기화
  INIT_VIEWS_KPI_SEARCH_POPUP: 'INIT_VIEWS_KPI_SEARCH_POPUP', //* KPI 검색 팝업 ON/OFF 설정
  INIT_VIEWS_DEPARTMENT_SEARCH_POPUP: 'INIT_VIEWS_DEPARTMENT_SEARCH_POPUP', //* 부서 검색 팝업 ON/OFF 설정
  INIT_VIEWS_MANAGER_SEARCH_POPUP: 'INIT_VIEWS_MANAGER_SEARCH_POPUP', //* 담당자 검색 팝업 ON/OFF 설정
  INIT_VIEWS_FILES_UPLOAD_POPUP: 'INIT_VIEWS_FILES_UPLOAD_POPUP', //* 파일 업로드 팝업 ON/OFF 설정

  INIT_INPUT_STRATEGY_INVALID: 'INIT_INPUT_STRATEGY_INVALID', //* 유효성 체크 결과
  INIT_IS_GRID_DRAG: 'INIT_IS_GRID_DRAG', //* 그리드 드래그온 드롭 ON/OFF
};

//* MUTATIONS CONSTANT
export const mutations = {
  // TODO: SET CONSTANT DECLARATION
  SET_STRATEGY_ESTABILSHMENT_LIST: 'SET_STRATEGY_ESTABILSHMENT_LIST', //* 전략과제 리스트 저장
  SET_STRATEGY_ESTABILSHMENT_ITEM: 'SET_STRATEGY_ESTABILSHMENT_ITEM', //* 전략과제 아이템 저장

  SET_STRATEGY_ESTABILSHMENT_CONNECT_LIST:
    'SET_STRATEGY_ESTABILSHMENT_CONNECT_LIST', //* 전략과제 연결 정보(과제,KPI) 저장
  SET_STRATEGY_EXCEL_DATA: 'SET_STRATEGY_EXCEL_DATA', //* 전략과제 EXCEL 데이터 저장
  SET_UPLOAD_EXCEL_FORM: 'SET_UPLOAD_EXCEL_FORM', //* 전략과제 EXCEL 업로드 양식 저장

  SET_KPI_INFO: 'SET_KPI_INFO', //* KPI 정보 저장
  SET_KPI_SEARCH_LIST: 'SET_KPI_SEARCH_LIST', //* KPI 검색 리스트 저장
  SET_STG_SEARCH_INFO: 'SET_STG_SEARCH_INFO', //* 전략과제 조회시 검색 정보 저장
  SET_UPPER_DEPT: 'SET_UPPER_DEPT', //* 상위 부서 검색

  SET_FILE_LIST: 'SET_FILE_LIST', //* 파일 정보 저장
  SET_VIEWS_KPI_SEARCH_POPUP: 'SET_VIEWS_KPI_SEARCH_POPUP', //* KPI 검색 팝업 ON/OFF 설정
  SET_VIEWS_DEPARTMENT_SEARCH_POPUP: 'SET_VIEWS_DEPARTMENT_SEARCH_POPUP', //* 부서 검색 팝업 ON/OFF 설정
  SET_VIEWS_MANAGER_SEARCH_POPUP: 'SET_VIEWS_MANAGER_SEARCH_POPUP', //* 담당자 검색 팝업 ON/OFF 설정
  SET_VIEWS_FILES_UPLOAD_POPUP: 'SET_VIEWS_FILES_UPLOAD_POPUP', //* 파일 업로드 팝업 ON/OFF 설정
  SET_INPUT_STRATEGY_INVALID: 'SET_INPUT_STRATEGY_INVALID', //* 전략과제 신규/수정 form 유효성
  SET_IS_GRID_DRAG: 'SET_IS_GRID_DRAG', //* 그리드 드래그온 드롭 ON/OFF
};

//* ROOT ACTIONS CONSTANT
export const rootActions = {
  ...Object.entries(actions).reduce((acc, cur) => {
    acc[cur[0]] = `strategyEstabilshment/${cur[1]}`;
    return acc;
  }, {}),
};

//* ROOT MUTATIONS CONSTANT
export const rootMutations = {
  ...Object.entries(mutations).reduce((acc, cur) => {
    acc[cur[0]] = `strategyEstabilshment/${cur[1]}`;
    return acc;
  }, {}),
};
